import { observer } from 'mobx-react-lite';
import qs from 'qs';
import { ReactElement, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ACDLError } from '../../../models/error.model';
import { useAuthService } from '../auth.service';
import { ConfirmEmail } from '../components/emailConfirmation/ConfirmEmail';

export type ResendStatus = 'NotSent' | 'Sending' | 'Sent';
export type ConfirmationStatus = 'InProgress' | 'Success' | 'Failed';

export const ConfirmEmailContainer = observer((): ReactElement => {
  const authService = useAuthService();

  const [confirmationStatus, setConfirmationStatus] = useState<ConfirmationStatus>('InProgress');
  const [resendStatus, setResendStatus] = useState<ResendStatus>('NotSent');
  const location = useLocation();
  const history = useHistory();

  const handleResendActivationEmail = async (): Promise<void> => {
    setResendStatus('Sending');
    const parsedSearch = qs.parse(location.search.slice(1)) as { email: string };

    await authService.resendConfirmationEmail({ email: parsedSearch.email });
    setResendStatus('Sent');
  };

  const confirmEmail = async (): Promise<void> => {
    setConfirmationStatus('InProgress');
    const parsedSearch = qs.parse(location.search.slice(1)) as { email: string; token: string };

    const result = await authService.confirmEmail({ email: parsedSearch.email, token: parsedSearch.token });

    if (result instanceof ACDLError) {
      setConfirmationStatus('Failed');
    } else {
      setConfirmationStatus('Success');
      setTimeout(() => {
        history.push('/login');
      }, 10000);
    }
  };

  const handleGoToLoginClick = (): void => {
    history.push('/login');
  };

  useEffect(() => {
    void confirmEmail();
  }, []);

  return (
    <ConfirmEmail
      resendStatus={resendStatus}
      confirmationStatus={confirmationStatus}
      onResendActivationEmailClick={handleResendActivationEmail}
      onGoToLoginClick={handleGoToLoginClick}
    />
  );
});
